/**
 * SEO 配置 - chat (Español)
 */

export default {
    chat: {
        title: 'Chat IA - Asistente Multimodelo | WeryAI',
        description:
            'Chatea con los mejores modelos de IA en WeryAI. Compara respuestas lado a lado en múltiples ventanas. Genera imágenes, vídeos y música desde un solo espacio de trabajo.',
        keywords:
            'chat IA, asistente IA, chat multimodelo, chatbot IA, comparar modelos IA, chat IA lado a lado, alternativa GPT, espacio de trabajo IA, WeryAI',
        og_title: 'Chat IA - Asistente Multimodelo | WeryAI',
        og_description:
            'Chatea con los mejores modelos de IA y compara respuestas lado a lado. Genera imágenes, vídeos y más. Prueba gratis en WeryAI.',
        twitter_title: 'Chat IA - Asistente Multimodelo | WeryAI',
        twitter_description:
            'Chatea con los mejores modelos de IA y compara respuestas lado a lado. Genera imágenes, vídeos y más. Prueba gratis en WeryAI.',
    },
}
